import Vue from 'vue'
import Vuex from 'vuex'
import Stud from './sutd'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        city: 'Город',
        polz: 1,
        inAk: false,
        kol:8,
        sor:"По рейтингу",
    },
    modules:{
        a: Stud,
    }
})